export default ({ i18n }) => ({
  CLASS_LABEL_TEXT: i18n.t`Class`,
  GROUP_LABEL_TEXT: i18n.t`Group`,
  WHOLE_CLASS_TEXT: i18n.t`Whole class`
});
